import { render, staticRenderFns } from "./PosItemClass.vue?vue&type=template&id=990f1036&"
import script from "./PosItemClass.vue?vue&type=script&lang=js&"
export * from "./PosItemClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports